import { Controller } from "stimulus"

export default class extends Controller
  formatPopup: (event) ->
    event.preventDefault()
    url = event.target.getAttribute('href')
    window.open url,
      '',
      'left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0'